module.exports = __webpack_public_path__ + "static/diamond-logo-85f670e97d5a34714ff4e660836494b6.png";